import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { BaseHttpService } from '@services/http/base-http.service';
import { Router } from '@angular/router';
import { environment } from '@environments';
import { CachedDataService } from '@services/data/cached-data.service';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '@services/http/auth.service';
import {Setting} from "@models";
@Injectable()
export class SettingsService extends BaseHttpService {

	constructor(protected httpClient: HttpClient,
		protected cachedDataService: CachedDataService,
        protected router: Router,
        protected authService: AuthService
		) {
			 super(httpClient, cachedDataService, router, authService);
	 }

    openSettingsSubject:Subject<any> = new Subject<any>();
    openSettingsObservable = this.openSettingsSubject.asObservable()

	getTimers(deviceId: string,provider: string): Observable<any> {
		const uri = environment.apiUri + 'setting/timer';
		const params = new HttpParams()
		.set('deviceId', deviceId)
		.set('provider', provider)

		return super.send('GET', uri, params);
  }

	setTimers(deviceId: string,timers: string): Observable<any> {
		const uri = environment.apiUri + 'setting/timer';
    return super.send('PUT', uri, null,true,{deviceId:deviceId,timers:timers});
	}

  getSettings(deviceId: string,provider: string): Observable<Setting> {
		const uri = environment.apiUri + 'setting';
		const params = new HttpParams()
		.set('deviceId', deviceId)
		.set('provider', provider)
		.set('generation', "v2")

		return super.send('GET', uri, params);
	}
	saveSettings(deviceId: string,settings): Observable<any> {
		const uri = environment.apiUri + 'setting';
		return super.send('PUT', uri, null,true,{deviceId:deviceId,settings:settings});
  }
    getSettingsTemplate(deviceId: string): Observable<any> {
		const uri = environment.apiUri + 'setting/template';
		const params = new HttpParams()
		.set('deviceId', deviceId)

		return super.send('GET', uri, params);
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/settings.service.ts